import { BASE_URL } from "@/dashboardQueries";
import { PaginatedResponse } from "@/models/Dashboard";
import { Form } from "@/models/form";
import { useFlowStore } from "@/store/flow";
import { getActionBasedOnType } from "@/utils/flows";
import axios from "axios";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { ActionPicker } from "./ActionPicker";

export const FlowMenu = () => {
  const { activeNode, nodes } = useFlowStore();

  const action = useMemo(
    () => getActionBasedOnType(activeNode?.data.type),
    [activeNode?.data.type] // Ensure this updates when the activeNode's type changes
  );

  return (
    <div className="p-4">
      {activeNode && action ? (
        action.component // Show the node's component
      ) : (
        <div>
          {nodes.length === 0 ? (
            <>
              <div>
                <h3 className="dark:text-zinc-300 text-sm">Select trigger</h3>
                <p className="text-xs dark:text-zinc-600 mt-0.5">
                  Pick a trigger to start this flow
                </p>
              </div>
            </>
          ) : (
            <div>
              <h3 className="dark:text-zinc-300 text-sm">Next step</h3>
              <p className="text-xs dark:text-zinc-600 mt-0.5">
                Pick the action for this step
              </p>
            </div>
          )}

          <div className="mt-3">
            <ActionPicker />
          </div>
        </div>
      )}
    </div>
  );
};
